const TYPE_EXPENSES_VISIBILITY = {
    PROMOCODE: 'promocode',
    CERTIFICATE: 'certificate',
};

const RU_TYPE_EXPENSES_VISIBILITY = {
    [TYPE_EXPENSES_VISIBILITY.PROMOCODE]: 'Промокод',
    [TYPE_EXPENSES_VISIBILITY.CERTIFICATE]: 'Сертификат',
};

const EN_TYPE_EXPENSES_VISIBILITY = {
    [TYPE_EXPENSES_VISIBILITY.PROMOCODE]: 'Promocode',
    [TYPE_EXPENSES_VISIBILITY.CERTIFICATE]: 'Сertificate',
};

const TYPE_EXPENSES_VISIBILITY_LANG_ADAPTER = {
    ru: RU_TYPE_EXPENSES_VISIBILITY,
    en: EN_TYPE_EXPENSES_VISIBILITY
};

module.exports = {
    TYPE_EXPENSES_VISIBILITY_LANG_ADAPTER
}